import React from "react";

interface InformationTableProps {
  children: React.ReactNode;
}

export const InformationTable = ({ children }: InformationTableProps) => (
  <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
    <table className="w-full border-separate border-spacing-0">
      <tbody>
        {children}
      </tbody>
    </table>
  </div>
)